import { render, staticRenderFns } from "./after.vue?vue&type=template&id=5dea21c8"
import script from "./after.vue?vue&type=script&lang=js"
export * from "./after.vue?vue&type=script&lang=js"
import style0 from "./after.vue?vue&type=style&index=0&id=5dea21c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports